import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
    activeID: ''
}

const getters = {
    getActive: (state) => state.activeID
}

const mutations = {
    setActive(state,data) {
        state.activeID = data;
    }
}


export default new Vuex.Store({
    state,
    getters,
    mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js